import React from "react";
import Alert from "react-bootstrap/Alert";
import { myUtilities } from "../../Utils";

const AlertWindow = ({ id, defaultMessage, overRideStyle = "" }) => (
  <Alert style={overRideStyle} className="my-alert-class" variant="danger">
    <p>
      {myUtilities.accountSpecificLanguage(id, defaultMessage)}
    </p>
  </Alert>
);
export default AlertWindow;
